<template>
  <!-- popup (s) -->
  <div id="inactiveAccountPop" class="popWrap nowOpen" tabindex="-1" role="dialog">
    <div class="popup">
      <div class="popContain">
        <div class="popCont full hasBtn">
          <div class="popHead">
            <h1 class="titH1">휴면해제</h1>
          </div>
          <div class="popBody">
            <div class="popInner">
              <!-- 본문 (s) -->
              <section>
                <div class="guideMsg">
                  <p class="txtL">
                    고객님의 소중한 개인정보!
                    <br />
                    웰몰이 지켜드릴께요
                  </p>
                  <p class="txt">
                    고객님의 ID는 웰몰을 1년동안 장기
                    <br />
                    미이용하여 휴면계정으로 전환되었습니다.
                  </p>
                  <p class="txtXS">
                    전환일
                    <span>{{ year }}</span>
                    년
                    <span>{{ month }}</span>
                    월
                    <span>{{ day }}</span>
                    일
                  </p>
                  <p class="txt pointC1 bold">
                    휴면해제하기 버튼으로 간단하게 다시 웰몰을 이용해보세요.
                  </p>
                </div>
              </section>
              <!-- 본문 (e) -->
            </div>
          </div>

          <div class="btnArea sticky">
            <button type="button" class="btn_p" @click="$emit('activeAccount')">
              휴면해제하기
            </button>
          </div>

          <button type="button" class="btnIco_close" @click="$emit('close')">
            <span>팝업 닫기</span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- popup (e) -->
</template>

<script>
export default {
  name: 'LoginInactiveAccount',
  props: ['lockDate'],
  data() {
    return {
      year: this.lockDate.substring(0, 4),
      month: this.lockDate.substring(4, 6),
      day: this.lockDate.substring(6),
    };
  },
};
</script>
